import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ROUTESPATH } from '@core/config/constants';
import { TokenService } from '@services/generic/token.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectCreatorGuard implements CanActivate {
  constructor(
    private router: Router,
    private readonly tokenService: TokenService
  ) {}

  async canActivate() {
    if (
      ['VV-CL-PROJECT-CREATOR', 'VV-CL-ADMIN'].includes(TokenService.user.role)
    ) {
      return await this.tokenService
        .validToken()
        .then(() => {
          return true;
        })
        .catch(() => {
          this.router.navigate([ROUTESPATH.LOGIN]);
          return false;
        });
    } else {
      this.router.navigate([ROUTESPATH.HOME]);
      return false;
    }
  }
}
